import { useState, useEffect } from "react";
import { FileInfo } from "./lib";
import UploadPanel from "./UploadPanel";
import HarFileInfo from "./HarFileInfo";
import { Button } from "antd";
import "./App.css";

const App = () => {
  const [fileInfo, setFileInfo] = useState<FileInfo | null>(null);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);

  return <>
    <div className="headline">
      Upload a HAR file extracted from viewing IG stories and you'll see the videos as links. Nothing is sent to the server.
    </div>
    <UploadPanel
      setFileInfo={setFileInfo}
    />
    {isProcessing &&
      <div className="processing">
        Processing...
      </div>
    }
    {fileInfo &&
      <>
        <h2>Results</h2>
        <HarFileInfo
          fileInfo={fileInfo}
          setIsProcessing={setIsProcessing}
        />
        <Button onClick={() => {
          setFileInfo(null);
          document.location = document.location;
        }}>Clear</Button>
      </>
    }
  </>;
};

export default App;